import axios from "axios"

export const sendMessage = async (data: any): Promise<any> => {
  const encode = (data: any) => {
    return Object.keys(data)
      .map(
        (key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key])
      )
      .join("&")
  }

  try {
    return await axios.post(
      "/",
      encode({
        "form-name": "innovation-lab-form",
        ...data,
      }),
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    )
  } catch (error) {
    return {
      error: true,
    }
  }
}
export default sendMessage
